/* Routing */
import {useNavigate, useParams} from "react-router-dom";
/* React hooks */
import {useEffect, useState} from "react";
/* Components */
import useAuth from "../../hooks/useAuth";
import {getActivityInfos, updateActivityInfos} from "../../api/admin/activityReq";
import useData from "../../hooks/useData";
import FormButtons from "../../components/common/FormButtons";
import {getErrorListFromValidation, patternListChoices, removeErrorList, validateFormInput} from "../../helper/tools";
import Icon from "../../components/common/Icon";


export default function FormActivities({ data, legend, apiActivities }) {

    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const { activityInfos, setActivityInfos } = useData();
    const [values, setValues] = useState({});
    const navigate = useNavigate();

    const onChange = (e) => {
        setValues({...values, name : e.target.value})
        validateFormInput(e)
    };

    const apiActivityInfos = async () => {
        const response = await getActivityInfos(token, id);
        setActivityInfos(response)
    }

    useEffect(() => {
        if (id != 0) {
            apiActivityInfos()
        }
    }, [ id ]);

    useEffect(() => {
        if (activityInfos) {
            setValues(activityInfos)
        }
    }, [ activityInfos ]);

    const handleSubmit = (e) => {
        e.preventDefault()
        let body = {
            id: id,
            name: values?.name,
        }
        updateActivityInfos(token, body)
            .then(response => {
                removeErrorList()
                if (!response?.response?.data?.error) {
                    navigate("/admin/activites")
                    apiActivities()
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const handleRemoveModal = () => {
        navigate("/admin/activites")
    }

    return (
        <form method="POST" noValidate onSubmit={handleSubmit}>
            <fieldset className="mini">
                <Icon source="fa-solid fa-list" span={legend}/>
                <div className="form-input">
                    <label htmlFor="name">Nom</label>
                    <input pattern={patternListChoices?.lastname} required="required" type="text" name="name" defaultValue={values?.name} onChange={onChange}/>
                </div>
                <FormButtons handleRemoveModal={handleRemoveModal}/>
                <div className="errors"></div>
            </fieldset>
        </form>
    )
}